import { Container } from 'react-bootstrap'

import HeaderNoMenu from '../components/statuses/HeaderNoMenu'
import FailedToLoadData from '../components/statuses/FailedToLoadData'
import Disabled from '../components/statuses/Disabled'
import PaymentIncomplete from '../components/statuses/PaymentIncomplete'
import VerifyEmail from '../components/statuses/VerifyEmail'
import SignupPage from './SignupPage'
import MembershipExpired from '../components/statuses/MembershipExpired'

const StatusMessagePage = ({ status }) => {
  let content

  switch (status) {
    case ("failedToLoadData"):
      content = <FailedToLoadData />
      break
    case ("disabled"):
      content = <Disabled />
      break
    case ("paymentIncomplete"):
      content = <PaymentIncomplete />
      break
    case ("verifyEmail"):
      content = <VerifyEmail />
      break
    case ("signup"):
      content = <SignupPage />
      break
    case ("expired"):
      content = <MembershipExpired />
      break
    default: content = <FailedToLoadData />
  }

  return (
    <>
      <HeaderNoMenu />
      <Container className="d-flex flex-column align-items-center text-center position-relative" style={{ paddingTop: "4.8375rem" }}>
        <div className="d-flex flex-column align-items-center mt-5">
          {content}
        </div>
      </Container>
    </>
  )
}

export default StatusMessagePage